/* eslint-disable react/prop-types */
import React from 'react'

import { Card, AccordionSummary, Typography } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'
import { formatDuration, timeAgo } from './utils.js'
import { sanitizeInput } from '../utils.js'

const spellMap = {
  21: 'SummonerBarrier',
  1: 'SummonerBoost',
  14: 'SummonerDot',
  3: 'SummonerExhaust',
  4: 'SummonerFlash',
  6: 'SummonerHaste',
  7: 'SummonerHeal',
  13: 'SummonerMana',
  30: 'SummonerPoroRecall',
  31: 'SummonerPoroThrow',
  11: 'SummonerSmite',
  39: 'SummonerSnowURFSnowball_Mark',
  32: 'SummonerSnowball',
  12: 'SummonerTeleport'
}

const runeMap = {
  8000: 'Yellow',
  8100: 'Red',
  8200: 'Blue',
  8300: 'Cyan',
  8400: 'Green'
}

const getKdaColor = (kda) => kda > 5 ? 'orange' : kda >= 3 ? 'yellow' : 'white'

const PlayerList = ({ players, style }) => (
  <div style={style}>
    {players.map((p, index) => (
      <div key={index} style={{ display: 'flex', alignItems: 'center', margin: '4px 0' }}>
        <img src={`photos/championImages/Icons/${sanitizeInput(p.championName)}.png`} alt={p.championName} style={{ width: 27, height: 27, marginRight: 4, borderRadius: '100%' }}/>
        <Typography variant="caption" style={{ color: 'white', fontSize: 12, width: 100, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.summonerName}</Typography>
      </div>
    ))}
  </div>
)

export const AccordionSummaryInfo = ({ game, searchedName, gameIndex }) => {
  const participant = game.participants.find(p => p.puuid === searchedName)
  if (!participant) return null
  const { kills, deaths, assists } = participant.stats
  const kda = ((kills + assists) / deaths).toFixed(2)

  const winners = game.participants.filter(p => p.win)
  const losers = game.participants.filter(p => !p.win)
  const resultColor = participant.win ? '#28344e' : '#63252e'
  const itemResultColor = participant.win ? '#38496e' : '#6e414a'

  const timeAgoText = timeAgo(game.gameCreation)
  const gameDurationText = formatDuration(game.gameDuration)
  return (
    <AccordionSummary expandIcon={<ExpandMore />} aria-controls={`panel${gameIndex}-content`} id={`panel${gameIndex}-header`} style={{ backgroundColor: resultColor }} >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: 10 }}>
        <Typography variant="subtitle1" style={{ color: 'white' }}>ARAM</Typography>
        <Typography variant="subtitle2" style={{ color: 'white', whiteSpace: 'nowrap' }}>{timeAgoText}</Typography>
        <Typography variant="subtitle1" style={{ textAlign: 'center', width: 100, color: participant.win ? 'green' : 'red', whiteSpace: 'nowrap' }}>
          {participant.win ? 'WIN' : 'LOSS'} {gameDurationText}
        </Typography>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: 10 }}>
        <img src={`photos/championImages/Icons/${sanitizeInput(participant.championName)}.png`} alt={participant.championName} style={{ width: 70, height: 70, borderRadius: '100%' }} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: 5 }}>
        <img src={ `photos/sumSpells/${spellMap[participant.stats.summonerSpell1Id]}.png`} alt={participant.championName} style={{ width: 32, height: 32, marginLeft: 5 }} />
        <img src={ `photos/sumSpells/${spellMap[participant.stats.summonerSpell2Id]}.png`} alt={participant.championName} style={{ width: 32, height: 32, marginTop: 2, marginLeft: 5 }} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginRight: 16 }}>
        <img src={ `photos/runes/${participant.stats.runes.styles[0].selections[0].perk}.png`} alt={participant.championName} style={{ width: 32, height: 32, marginLeft: 5 }} />
        <img src={ `photos/runes/${runeMap[participant.stats.runes.styles[1].style] || 'RunesIcon'}.png`} alt={participant.championName} style={{ width: 32, height: 32, marginTop: 2, marginLeft: 5, borderRadius: '100%' }} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', marginRight: 16, alignItems: 'center', justifyContent: 'center', width: 100, textAlign: 'center' }}>
        <Typography variant="subtitle2" style={{ color: 'white', fontSize: '1.3em' }}>
          {kills}
          <span style={{ margin: '0 4px' }}>/</span>
          <span style={{ color: '#c43347' }}>{deaths}</span>
          <span style={{ margin: '0 4px' }}>/</span>
          {assists}
        </Typography>
        <Typography variant="subtitle2" style={{ color: getKdaColor(kda), whiteSpace: 'nowrap' }}>{`${kda} KDA`}  </Typography>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginLeft: 20 }}>
        {[0, 3].map(start => (
          <div style={{ display: 'flex' }} key={start}>
            {participant.stats.items.slice(start, start + 3).map((item, i) => (
              item
                ? (
                <img key={i} src={`photos/items/${item}.png`} alt={item || 'Empty Slot'} style={{ width: '35px', height: '35px', margin: '1px' }}/>
                  )
                : (
                <Card key={i} sx={{ width: '35px', height: '35px', margin: '1px', backgroundColor: itemResultColor, display: 'flex', alignItems: 'center', justifyContent: 'center' }}/>
                  )
            ))}
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginLeft: 30, width: 200 }}>
      <Typography variant="h6" style={{ color: 'white', marginBottom: '10px', fontSize: 15 }}>Casts</Typography>
        {[0, 3].map(rowIndex => (
          <div style={{ display: 'flex' }} key={rowIndex}>
            {rowIndex === 0
              ? ['Q', 'W', 'E'].map(spell => (
                  <div key={spell} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '5px' }}>
                    <img
                      src={`photos/spells/${sanitizeInput(participant.championName)}${spell}.png`}
                      alt={`Spell ${spell}`}
                      style={{ width: '25px', height: '25px', marginBottom: '5px' }}
                    />
                    <Typography variant="subtitle2" style={{ color: 'white' }}>
                      {participant.stats.casts[spell]}
                    </Typography>
                  </div>
                ))
              : ['R'].concat(['summonerSpell1Id', 'summonerSpell2Id']).map(spell => (
            <div key={spell} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '5px' }}>
              <img
                src={
                  spell.startsWith('summonerSpell')
                    ? `photos/sumSpells/${spellMap[participant.stats[spell]]}.png`
                    : `photos/spells/${sanitizeInput(participant.championName)}${spell}.png`
                }
                alt={spell.startsWith('summonerSpell') ? participant.championName : `Spell ${spell}`}
                style={{ width: '25px', height: '25px', marginBottom: '5px' }}
              />
              <Typography variant="subtitle2" style={{ color: 'white' }}>
                {spell === 'summonerSpell1Id'
                  ? participant.stats.summonerSpell1Casts
                  : spell === 'summonerSpell2Id'
                    ? participant.stats.summonerSpell2Casts
                    : participant.stats.casts[spell]
                }
              </Typography>
            </div>
                ))}
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginLeft: 20 }}>
        <PlayerList players={winners} style={{ flexDirection: 'column', alignItems: 'center', marginRight: 2 }} />
        <PlayerList players={losers} style={{ flexDirection: 'column', alignItems: 'center', marginLeft: 20 }}/>
      </div>
    </AccordionSummary>
  )
}
